'use client'
import Link from "next/link";
import { ReactNode, useEffect, useState } from "react";


export default function BlogWrapper({ children, slug, tagUrl, id, className }: { className?: string; children: ReactNode, slug: string, tagUrl: string, id: string }) {
    const [BlogTags, setBlogTags] = useState('')
    const [innerWidth, setInnerWidth] = useState(0);

    useEffect(() => {
        const handleGetTags = async () => {
            try {
                const res = await fetch(tagUrl);
                const data = await res.json();
                const tags = data.map((item: any) => item.id);
                setBlogTags(tags)
            } catch (error) { }
        }
        handleGetTags()
    }, [tagUrl])

    useEffect(() => {
        const handleResize = () => {
            setInnerWidth(window.innerWidth);
        };
        if (window) {
            window.addEventListener("resize", handleResize);
            handleResize();
        }
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <Link
            href={`/blog/${slug}?tags=${BlogTags}`}
            target={innerWidth < 760 ? '_self' : "_blank"}
            className={className}
        >
            {children}
        </Link>
    )
}